/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import PartnerKyc from "./PartnerKyc";

export default PartnerKyc;
